import { DialogTitle } from "../dialogs";
import * as React from "react";
import { CSSProperties, useEffect, useRef } from "react";
import { Box, Dialog, DialogContent, useTheme } from "@mui/material";
import { useCurrentMeeting } from "./contexts/currentMeeting";
import { formatDateTime } from "./tools";
import { Duration } from "conference/components/DurationFields";
import { useLogger } from "@dvrt/web-phone-client";
import { useZoom } from "./zoom";
import { FormattedMessage, MessageDescriptor } from "react-intl";

export const MeetingDialogTitle = () => {
    const currentMeeting = useCurrentMeeting();

    return (
        <DialogTitle>
            <div style={{ fontSize: "1.5em" }}>{currentMeeting.meeting.summary}</div>
            <div style={{ fontSize: "0.8em", opacity: 0.7 }}>
                {formatDateTime(currentMeeting.meeting.startTime)} (
                <Duration value={currentMeeting.meeting.length} />)
            </div>
        </DialogTitle>
    );
};

export const RootContainer = ({ children, style }: { children?: React.ReactNode; style?: React.CSSProperties }) => {
    const theme = useTheme();
    return (
        <>
            <Box
                sx={{
                    backgroundColor: theme.palette.background.paper,
                    color: theme.palette.text.primary,
                    position: "fixed",
                    width: "100%",
                    height: "100%",
                    top: 0,
                    left: 0,
                    ...style,
                }}
            >
                {children}
            </Box>
        </>
    );
};

export const AlertDialog = ({ title, children }: { title?: MessageDescriptor; children: React.ReactNode }) => {
    return (
        <Dialog open={true}>
            {title && (
                <DialogTitle>
                    <FormattedMessage {...title} />
                </DialogTitle>
            )}
            <DialogContent style={{ padding: "1.5em 2em" }}>{children}</DialogContent>
        </Dialog>
    );
};

type VideoPros = {
    track: MediaStreamTrack;
    style?: CSSProperties;
    className?: string;
};

export const Video = ({ track, style, className }: VideoPros) => {
    const ref = useRef<HTMLVideoElement>(null);
    const logger = useLogger("MediaComp:Video");
    const { eventHandlers, zoomStyle } = useZoom(ref);

    useEffect(() => {
        logger.debug("set track id", track.id, "kind", track.kind);
        ref.current.srcObject = new MediaStream([track]);
    }, [track.id]);

    // eslint-disable-next-line jsx-a11y/media-has-caption
    return <video autoPlay ref={ref} style={{ ...style, ...zoomStyle }} className={className} {...eventHandlers} />;
};
